import { faker } from '@faker-js/faker'

import { asBuilder } from '../asBuilder'
import { AdminReviewVerificationStatusRequest } from '../../contracts/review'

export const getAdminReviewVerificationStatusRequest = asBuilder((): AdminReviewVerificationStatusRequest => {
  return {
    reviewIds: faker.helpers.multiple(() => faker.number.int()),
    rewardType: 'COMPLETED_PROGRESSES_WITH_MINIMUM_COUNTS',
    verificationStatus: faker.helpers.arrayElement(['PENDING', 'COMPLETED', 'REJECTED']),
  }
})
